import { useNavigate } from 'react-router-dom';
import styles from './EventCard.module.css';
import * as routes from '../../../../constants/Routes';
import { useState } from 'react';
import { QrCodeModal } from './QrCodeModal';

export function EventCard({ event }) {
  const navigate = useNavigate();
  const [qRCodeModalIsOpen, setQRCodeModalIsOpen] = useState(false);

  return (
    <div
      className="col-12 col-sm-12 col-md-6 col-lg-4"
      key={event.id}
      id={event.id}
    >
      <div className={styles.cardReveal}>
        <div className={styles.cardBanner} style={{ position: 'relative' }}>
          <img src={event.image} alt="imagem" />
        </div>
        <div className={`${styles.cardTitle} text-truncate p-4`}>
          {event.title && (
            <span
              style={{
                marginTop: '8px',
                marginBottom: '8px',
                fontWeight: 600,
                display: 'block',
              }}
            >
              {event.title}
            </span>
          )}
          {event.startDate && event.endDate && (
            <span
              style={{
                marginTop: '8px',
                marginBottom: '8px',
                fontWeight: 500,
                display: 'block',
              }}
            >
              Início do evento:{' '}
              {new Date(event.startDate).toLocaleDateString('pt-BR')}
            </span>
          )}
          {event.endDate && (
            <span
              style={{
                marginTop: '8px',
                marginBottom: '8px',
                fontWeight: 500,
                display: 'block',
              }}
            >
              Fim evento: {new Date(event.endDate).toLocaleDateString('pt-BR')}
            </span>
          )}
        </div>
        <div className={`${styles.cardAction} mt-4`}>
          <button
            onClick={() => {
              navigate(`${routes.EVENT}/${event.id}`);
            }}
          >
            <i className="material-icons-outlined mx-2">add</i>
            <span>Mais detalhes</span>
          </button>
          <button
            className={styles.cta}
            onClick={() => {
              setQRCodeModalIsOpen(true);
            }}
            disabled={
              !(
                event.startDate &&
                event.endDate &&
                new Date(event.startDate) <= new Date() &&
                new Date() <= new Date(event.endDate)
              )
            }
          >
            <i className="material-icons-outlined mx-2">share</i>
            <span>Gerar QR Code</span>
          </button>
        </div>
      </div>
      <QrCodeModal
        open={qRCodeModalIsOpen}
        onClose={() => setQRCodeModalIsOpen(false)}
        eventId={event.id}
      />
    </div>
  );
}
